import React, {useEffect, useState} from "react";
import {fetchApi} from "@julienbdx/nous-sommes-common";
import {ENDPOINT} from "../../../config/config";

export function MembersTag(id:number){
    const [members,setMembers] = useState(-1);
    useEffect(() => {
        fetchApi(ENDPOINT, "tags/" + id + "/individus", {credentials: "include"})
            .then((res: any) => {
                console.log("tag member : ", res["hydra:totalItems"]);
                setMembers(res["hydra:totalItems"]);
            })
    },[id] )
    return members;
}